import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { HStack } from "@/components/ui/hstack";
import { Divider } from "@/components/ui/divider";
import { Center } from "@/components/ui/center";
import React, { useContext } from 'react';
import InputHandle from "../basic/InputHandle";
import i18n from "i18n-js";
import { MediaContext } from "../media/MediaContext";
import {  IconMC } from '@/components/media/IconsV2';

export default function EndNode({ selected }) {
    const { nodeHighlighting } = useContext(MediaContext)

    const borderRadius = selected ? 'rounded-tl-2 rounded-tr-2' : 'rounded-tl-5 rounded-tr-5'

    const getColor = (isBorder) => {
        if (nodeHighlighting['endOfWorkflow']?.border) {
            if (nodeHighlighting['endOfWorkflow']?.error) {
                return isBorder ? 'border-error-600' : 'shadow-error-600'
            }
            if (nodeHighlighting['endOfWorkflow']?.info) {
                return isBorder ? 'border-ina-yellow' : 'shadow-ina-yellow'
            }
        }
        return isBorder ? 'border-primary-900' : 'shadow-primary-900'
    }

    return (
        <View
            style={{
                shadowColor: selected ? getColor(false) : "#000000",
                shadowOffset: {
                    width: selected ? 4 : 0,
                    height: 4,
                },
                shadowOpacity: selected ? 0.4 : 0.3,
                shadowRadius: selected ? 20 : 4.65,
                elevation: 8,
            }}
            className={` ${getColor(true)} ${selected || nodeHighlighting?.border ? "border-[4px]" : "border"} max-w-[340px] min-w-[340px] rounded-md pb-1 bg-[#FFFFFF] `}>
            <VStack>
                <HStack className={`${borderRadius} py-2 items-center bg-primary-900`}>
                    <Text className="font-bold text-secondary-50 my-2 mx-3 text-2xl">{i18n.t('stepType.end')}</Text>
                </HStack>
                <Divider />
                <Text className="text-secondary-900 mx-4 my-3 text-xl">{i18n.t('stepTypeInformation.endDescription')}</Text>
            </VStack>
            <View className="absolute -right-[52px] top-0 bg-primary-900 border border-primary-900 rounded-[4px] p-1">
                <IconMC className='text-primary-50' size={36} name='flag-checkered' />
            </View>
            <InputHandle nodeHighlighting={nodeHighlighting['endOfWorkflow']} />
        </View>
    );
}
